/**
 * Edit Mode Constants for Banner Builder
 *
 * Controls what users can edit in layouts:
 * - FULL_EDIT: Everything (default)
 * - TEXT_PRODUCT_IMAGE: Copy, product images, decorative elements (backgrounds, shapes)
 * - TEXT_PRODUCT: Copy and product images only (no background/image changes)
 * - PRODUCT_ONLY: Product images only (for licensing like FIFA/UCL)
 */

export const EDIT_MODE = {
  FULL_EDIT: 'full_edit',
  TEXT_PRODUCT_IMAGE: 'text_product_image',
  TEXT_PRODUCT: 'text_product',
  PRODUCT_ONLY: 'product_only',
};

export const EDIT_MODE_LABELS = {
  [EDIT_MODE.FULL_EDIT]: 'Full Edit',
  [EDIT_MODE.TEXT_PRODUCT_IMAGE]: 'Text + Product + Image',
  [EDIT_MODE.TEXT_PRODUCT]: 'Text + Product',
  [EDIT_MODE.PRODUCT_ONLY]: 'Product-Only',
};

// Product images - ALWAYS editable in ALL modes
// These prefixes identify product image elements by their element ID
export const ALWAYS_EDITABLE_PREFIXES = [
  'image_',
  'add_image_', // Manually added product images
];

// Field types that are ALWAYS editable (only true product images)
// Other image types like 'Image Upload' or 'additional_image' are NOT product images
// and should be restricted based on edit mode
export const ALWAYS_EDITABLE_FIELD_TYPES = [
  'Product Image',
];

// Text element prefixes - editable in TEXT_PRODUCT_IMAGE mode
export const TEXT_EDITABLE_PREFIXES = [
  'text_',
  'multi_line_',
  'static_txt_',
  'add_text_',
  'add_multi_line_text_',
];

// Text field types - editable in TEXT_PRODUCT_IMAGE mode
export const TEXT_EDITABLE_FIELD_TYPES = [
  'Text',
  'Multi Line Text',
  'Static Text',
  'Text Options',
  'Text from Spreadsheet',
  'additional_text',
  'additional_multi_line_text',
];

// Decorative element field types - editable in TEXT_PRODUCT_IMAGE mode
export const DECORATIVE_FIELD_TYPES = [
  'Background Color',
  'Background Color Picker',
  'Background Theme Color',
  'Background Theme Image',
  'Background Theme Image Multiple',
  'Background Image Upload',
  'Circle',
  'Rectangle',
  'additional_background_image',
];

// Decorative element prefixes - editable in TEXT_PRODUCT_IMAGE mode
export const DECORATIVE_EDITABLE_PREFIXES = [
  'bg_color_',
  'bk_img_',
  'add_bk_img_',
];

export default {
  EDIT_MODE,
  EDIT_MODE_LABELS,
  ALWAYS_EDITABLE_PREFIXES,
  ALWAYS_EDITABLE_FIELD_TYPES,
  TEXT_EDITABLE_PREFIXES,
  TEXT_EDITABLE_FIELD_TYPES,
  DECORATIVE_FIELD_TYPES,
  DECORATIVE_EDITABLE_PREFIXES,
};
